import { UserPermissions } from "shared/helpers/users";
import { Loadable, LoadableFactory } from "shared/loadable";

export type UserPermissionsState = Loadable<UserPermissions>;

export const initialUserPermissionsState: UserPermissionsState =
  LoadableFactory.loading();
